<template>
  <confetti v-if="showConfetti" class="fixed left-0 bottom-0 !h-auto z-[90]" />
</template>

<script lang="ts">
import Confetti from '@/components/confetti/Confetti.vue';

export default {
  name: 'ProfileConfetti',
  components: {
    Confetti,
  },
  props: {
    showConfetti: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
